import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "14",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M5.5 9.25v-4.5m3 4.5v-4.5M3.25 13h7.5A2.25 2.25 0 0 0 13 10.75v-7.5A2.25 2.25 0 0 0 10.75 1h-7.5A2.25 2.25 0 0 0 1 3.25v7.5A2.25 2.25 0 0 0 3.25 13"
    }, null, -1)
  ])))
}
export default { render: render }